import React, { FC } from 'react';
import { Container } from 'react-bootstrap';

import './ClBanner.scss';
import Resume from 'assets/files/ThienNhanResume.pdf';

const ClBanner: FC = () => {
  return (
    <Container
      fluid
      className="cl-banner d-flex flex-column justify-content-center"
    >
      <div data-aos="fade-up" data-aos-duration="1000" className="greeting">
        <p>Hi my name is</p>
      </div>
      <div data-aos="fade-up" data-aos-duration="1000" className="name">
        <h1>Le Nguyen Thien Nhan</h1>
      </div>
      <div data-aos="fade-up" data-aos-duration="1000" className="position">
        <h2>I am a Frontend Developer</h2>
      </div>
      <div data-aos="fade-up" data-aos-duration="1000" className="about-me">
        <p>Welcome to my portfolio.</p>
        <p>
          I am a web developer specializing in building (and occasionally
          designing). Currently, I am an Frontend Developer at a technology
          company and a freelancer.
        </p>
      </div>
      <div data-aos="fade-up" data-aos-duration="1000" className="download">
        <button
          onClick={() => window.open(Resume, '_blank')}
          className="download-resume"
        >
          Download CV
        </button>
      </div>
    </Container>
  );
};

export default ClBanner;
